import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row mx-auto col-lg-12 p-0 m-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_g_server_page = _resolveComponent("g-server-page");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.OnRefresh($event)))
                    }, "Aktualisieren")
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, { "show-command-bar": _ctx.showCommandBar }, {
            title: _withCtx(() => [
                _createVNode(_component_g_breadcrumb)
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_g_server_page, { templateUrl: _ctx.templateUrl }, null, 8, ["templateUrl"])
                ])
            ]),
            _: 1
        }, 8, ["show-command-bar"])
    ], 64));
}
